import React from 'react';
export function VideoShowcase() {
  return <section className="py-20 px-4 bg-[#0A1628] relative overflow-hidden" data-id="element-371">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C6F432] opacity-5 rounded-full blur-[100px] pointer-events-none" data-id="element-372"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-373">
        <h2 className="text-4xl md:text-5xl font-anton text-white mb-4" data-id="element-374">
          Explorá el interior del Megapack
        </h2>
        <p className="text-xl text-gray-400 mb-12 font-medium" data-id="element-375">
          Tu sistema completo de clases de pádel, listo para usar.
        </p>

        {/* Realistic iPhone Mockup */}
        <div className="relative mx-auto w-[280px] sm:w-[320px] h-[580px] sm:h-[650px] bg-black rounded-[3rem] p-[12px] shadow-[0_20px_50px_rgba(0,0,0,0.5),0_0_40px_rgba(198,244,50,0.15)] transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-376">
          {/* Notch */}
          <div className="absolute top-[12px] inset-x-0 h-6 w-32 bg-black mx-auto rounded-b-2xl z-20 flex justify-center items-center gap-2" data-id="element-377">
            <div className="w-12 h-1.5 bg-gray-800 rounded-full" data-id="element-378"></div>
            <div className="w-2 h-2 bg-gray-800 rounded-full" data-id="element-379"></div>
          </div>

          {/* Screen / Video */}
          <div className="relative w-full h-full rounded-[2.2rem] overflow-hidden bg-[#0F1F3D] isolate" data-id="element-380">
            <video src="https://cdn.magicpatterns.com/uploads/aoUfa2c1PFBZXK5f8qnQsi/screenrecording padel megapack.mov" autoPlay loop muted playsInline controls className="absolute inset-0 w-full h-full object-cover" data-id="element-381" />
          </div>

          {/* Side Buttons (Visual only) */}
          <div className="absolute top-24 -left-[4px] w-1 h-12 bg-gray-800 rounded-l-md" data-id="element-382"></div>
          <div className="absolute top-40 -left-[4px] w-1 h-12 bg-gray-800 rounded-l-md" data-id="element-383"></div>
          <div className="absolute top-32 -right-[4px] w-1 h-16 bg-gray-800 rounded-r-md" data-id="element-384"></div>
        </div>
      </div>
    </section>;
}